export default __webpack_public_path__ + "static/andre-ojos-e457d70db8b4d56919087521b8742bb4.jpg";